/** @flow */

import React, { Component, type Element } from "react";
import Step from "./step";

type OwnProps = $Exact<{
  data: Array<Object>,
  onChange?: (data?: Array<Object>, valid?: boolean) => any,
  onSubmit?: (data?: Array<Object>, valid?: boolean) => any,
  defaultStep?: number,
  isReadOnly?: boolean,
  children: Array<Element<typeof Step>>,
}>;

type State = $Exact<{
  expandedSteps: Map<number, boolean>,
  rawData: Array<
    $Exact<{
      data: Object,
      valid: boolean,
    }>,
  >,
  stepsCount: number,
}>;

function arrayReplace(state: Array<any>, index: number, newItem: Object): Array<any> {
  return [...state.slice(0, index), newItem, ...state.slice(index + 1, state.length)];
}

class CollapsibleWizard extends Component<OwnProps, State> {
  state = {
    expandedSteps: (new Map(
      this.props.children.map((_, index) => [index, index + 1 === this.props.defaultStep]),
    ): Map<number, boolean>),
    rawData: this.props.data || [{}],
    stepsCount: this.props.children.length,
  };

  onToggleStepEdit = (step: number) => () =>
    this.setState({
      expandedSteps: this.state.expandedSteps.set(step, !this.state.expandedSteps.get(step)),
    });

  onStepChange = (step: number) => (values?: Object = {}, valid?: boolean = true) =>
    this.setState(
      {
        rawData: arrayReplace(this.state.rawData, step, {
          data: values,
          valid,
        }),
      },
      () => {
        const { onChange } = this.props;
        onChange && onChange(this.getRawValues(), this.isValid());
      },
    );

  isValid() {
    return (
      this.state.rawData.length === this.props.children.length &&
      this.state.rawData.every(part => part.valid)
    );
  }

  getValidValues() {
    return this.state.rawData.filter(part => part.valid).map(part => part.data);
  }

  getRawValues() {
    return this.state.rawData.map(part => part.data);
  }

  render() {
    return (
      <div>
        {this.props.children.map(
          (element, index) =>
            !element.props.hidden &&
            React.cloneElement(element, {
              onChange: this.onStepChange(index),
              key: index,
              editable: this.state.expandedSteps.get(index),
              isTouched: true,
              data: this.state.rawData[index] && this.state.rawData[index].data,
              isValid: this.state.rawData[index] && this.state.rawData[index].valid,
              onToggleEdit: this.onToggleStepEdit(index),
              isCollapsable: true,
            }),
        )}
      </div>
    );
  }

  static defaultProps = {
    defaultStep: 1,
  };
}

export default CollapsibleWizard;
